import isEmptyObject from '../../src-i-adapter/helpers/is-empty-object';
/**
 * Given country, create locale string, taking first language.
 * See lib-locale for array of country objects
 *  * e.g. {
 *   name: 'locale.country.Argentina',
 *   iso_code: '032',
 *   code: 'AR',
 *   languages: [
 *     {
 *       name: 'Español',
 *       code: 'es'
 *     }
 *   ]
 * }
 * @param {object} country
 * @return {string|undefined} locale e.g. "es_AR" or undefined
 */
const getLocaleFromCountry = country => {
  if (
    !isEmptyObject(country) &&
    Array.isArray(country.languages) &&
    country.languages.length &&
    country.languages[0].code
  ) {
    const lang = country.languages[0];
    return `${lang.code}_${country.code}`;
  }
  return undefined;
};

export default getLocaleFromCountry;
